import "prebid.js/modules/appnexusBidAdapter";

import type {IPrebidJsBidder} from "header-bidding-client-base/modules/header-bidding/infrastructure/prebid-js/bidders/iPrebidJsBidder";
import type {AppNexusAdUnit} from "header-bidding-base/modules/config/domain/bidders/appNexusConfig";
import type {HeaderBiddingConfig} from "header-bidding-client-base/modules/config/domain/headerBiddingConfig";
import {Bidders} from "header-bidding-base/modules/header-bidding/domain/bidders";
import {PrebidJsBaseBidder} from "./prebidJsBaseBidder";

export class AppNexusBidder extends PrebidJsBaseBidder implements IPrebidJsBidder<AppNexusAdUnit> {
    public constructor(config: HeaderBiddingConfig) {
        super(config, Bidders.APPNEXUS);
    }
}
